export default __webpack_public_path__ + "static/media/Breath of the North.512b0f35.jpg";